module.exports = __webpack_public_path__ + "img/success.fcecaf11.gif";